// src/components/Leaderboard.js - VERSION CORRIGÉE

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaTrophy, FaMedal, FaCrown } from 'react-icons/fa';

const Leaderboard = () => {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchLeaderboard = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/');
                return;
            }

            try {
                const config = {
                    headers: {
                        'x-auth-token': token
                    }
                };
                // ✅ CORRECTION : URL relative au lieu d'URL absolue
                const res = await axios.get('/api/user/leaderboard', config); 
                setLeaderboardData(res.data);
                setLoading(false);
            } catch (err) {
                console.error('Erreur leaderboard:', err.response?.data || err.message);
                setError(t('leaderboard_error'));
                setLoading(false);
            }
        };

        fetchLeaderboard();
    }, [navigate, t]);

    if (loading) return <div className="container py-5 text-center">{t('leaderboard_loading')}</div>;
    if (error) return <div className="container py-5 alert alert-danger">{error}</div>;

    const topThree = leaderboardData.slice(0, 3);
    const restOfList = leaderboardData.slice(3);

    // Fonction pour styliser le Top 3
    const getTopThreeStyle = (index) => {
        switch (index) {
            case 0:
                return { 
                    icon: <FaCrown className="fs-1" />, 
                    color: 'text-warning', 
                    bg: 'bg-warning bg-opacity-10',
                    shadow: 'shadow-lg border border-warning' 
                };
            case 1:
                return { 
                    icon: <FaMedal className="fs-1" />, 
                    color: 'text-secondary', 
                    bg: 'bg-secondary bg-opacity-10',
                    shadow: 'shadow-md border border-secondary' 
                };
            case 2:
                return { 
                    icon: <FaMedal className="fs-1" />, 
                    color: 'text-info', 
                    bg: 'bg-info bg-opacity-10',
                    shadow: 'shadow-md border border-info'
                };
            default:
                return {};
        }
    };

    return (
        <div className="container py-5">
            <div className="text-center mb-5">
                <h1 className="mb-3 d-flex align-items-center justify-content-center">
                    <FaTrophy className="me-3 text-warning fs-2" />
                    {t('leaderboard_title')}
                </h1>
                <p className="lead text-muted">{t('leaderboard_description')}</p>
            </div>

            {leaderboardData.length === 0 ? (
                <div className="alert alert-info text-center">{t('leaderboard_no_data')}</div>
            ) : (
                <>
                    {/* SECTION TOP 3 */}
                    <div className="row justify-content-center mb-5 g-4">
                        {topThree.map((user, index) => {
                            const { icon, color, bg, shadow } = getTopThreeStyle(index);
                            const totalInvestment = user.totalInvestment ? (user.totalInvestment * 600) : 0; // Conversion USDT → FCFA

                            return (
                                <div key={user._id || index} className="col-lg-4 col-md-6">
                                    <div className={`card text-center h-100 p-4 ${shadow} ${bg}`}>
                                        <div className={`mb-3 ${color}`}>{icon}</div>
                                        
                                        <h3 className="mb-2 fw-bold text-dark">#{index + 1}</h3>
                                        <h5 className="mb-3 text-primary">
                                            {user.firstName} {user.lastName}
                                        </h5>
                                        
                                        {/* ✅ CORRECTION : Affichage des badges */}
                                        {user.badges && user.badges.length > 0 && (
                                            <div className="mb-3">
                                                <span className="badge bg-primary fs-6">
                                                    {user.badges[0]}
                                                </span>
                                            </div>
                                        )}
                                        
                                        <div className="mt-auto">
                                            <span className="badge bg-success fs-6 p-2">
                                                {Math.round(totalInvestment).toLocaleString('fr-FR')} FCFA
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* SECTION RESTE DU CLASSEMENT */}
                    <div className="card shadow-sm">
                        <div className="card-header bg-light">
                            <h4 className="mb-0">{t('leaderboard_full_list')}</h4>
                        </div>
                        <div className="list-group list-group-flush">
                            {restOfList.map((user, index) => {
                                const totalInvestment = user.totalInvestment ? (user.totalInvestment * 600) : 0;
                                
                                return (
                                    <div 
                                        key={user._id || index + 3} 
                                        className="list-group-item d-flex justify-content-between align-items-center py-3"
                                    >
                                        <div className="d-flex align-items-center">
                                            <strong className="me-3 fs-5 text-muted" style={{ minWidth: '40px' }}>
                                                #{index + 4} 
                                            </strong>
                                            <div>
                                                <div className="fw-semibold">
                                                    {user.firstName} {user.lastName}
                                                </div>
                                                {user.badges && user.badges.length > 0 && (
                                                    <small className="text-muted">{user.badges[0]}</small>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="text-end">
                                            <div className="fw-bold text-success fs-5">
                                                {Math.round(totalInvestment).toLocaleString('fr-FR')} FCFA
                                            </div>
                                            {user.totalGain > 0 && (
                                                <small className="text-muted">
                                                    Gains: {Math.round(user.totalGain * 600).toLocaleString('fr-FR')} FCFA
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Leaderboard;